import { createGetAllAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

const { useGetAll: useAdminReviews } = createGetAllAPI({
  getURL: query => `${BASE_URL}/teacher-classroom-reviews/?${stringify(query)}`,
});

const { useGetAll: useReviewerReviews } = createGetAllAPI({
  getURL: ({ reviewerId, ...query }) =>
    `${BASE_URL}/teacher-classroom-reviews/reviewers/${reviewerId}/?${stringify(query)}`,
});

export { useAdminReviews, useReviewerReviews };
